import { render } from "./GoQRcode.vue?vue&type=template&id=643aa43d&ts=true"
import script from "./GoQRcode.vue?vue&type=script&lang=ts"
export * from "./GoQRcode.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__